import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_521sy8ez50: FaireBrandEntity = {
  token: "b_521sy8ez50",
  type: "brand",
  name: "Jadelynn Brooke",
  avatarUrl:
    "https://cdn.faire.com/fastly/c498730c58986665f3a0e74e98aab609008492eb6bdf917285806f7fd271215c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2e681165e145c46d550f28531c0c56fe82fe1c07ac25ee6666c1ab13da6d9f91.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c498730c58986665f3a0e74e98aab609008492eb6bdf917285806f7fd271215c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2e681165e145c46d550f28531c0c56fe82fe1c07ac25ee6666c1ab13da6d9f91.jpeg",
  location: "Austin, TX, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 275,
  isTopShop: true,
  isInsider: true,
  description:
    "Jadelynn Brooke was built on happy-thoughts-always, 8 to 5 dance parties, lots of lattes, & a ton of love. We are three sisters who had a big dream to create apparel and gifts that have a positive happy vibe and empower the women of all ages that rock it. We are born and raised in Austin, TX and are passionate about creating a unique product with the best customer service for our boutique besties! Our Kindness & Confetti collection gives 10% of all net profits to matching military veterans with service dogs. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:28.641Z",
    importedBy: "entity-db-cli",
  },
};
